<template>
  <div>
    <f7-navbar :sliding="false">
      <f7-link
        icon-ios="f7:menu"
        icon-aurora="f7:menu"
        icon-md="material:menu"
        panel-toggle="left"
        class="icon-hamburguer"
      />
      <button
        v-if="pathBack != ''"
        class="button-back"
        @click="backTo"
      >
        <img class="ic-back">
      </button>
      <f7-nav-title class="title-head">
        {{ text.toUpperCase() }}
      </f7-nav-title>
      <!-- <f7-nav-right sliding>
      <ExportExcel
        v-if="list!=null"
        :list="list"
        :type-export="typeExport"
      />
      <ExtraElement
        v-for="(item, index) in elements"
        :key="index"
        :icon-enable="item.iconEnable"
        :text-enable="item.textEnable"
        :bagde-enable="item.badgeEnable"
        :info="item.info"
      />
    </f7-nav-right> -->

      <f7-nav-right class="nav-right">
        <selectLanguage
            :languages="languages"
            :language-selected="languageSelected"
            @changeLanguage="changeLanguage"
        />
        <f7-link @click="showPopUp = !showPopUp">
          <f7-icon
            slot="media"
            color="red"
            md="f7:info_circle_fill"
            size="40px"
          />
        </f7-link>
      </f7-nav-right>
    </f7-navbar>
    <DxPopup
      :visible="showPopUp"
      :drag-enabled="false"
      :close-on-outside-click="false"
      :on-hidden="onHidden"
      :show-title="true"
      :show-close-button="true"
      width="480px"
      height="75%"
      :title="$t('navBar.popUp.tittle')"
    >
      <template #content>
        <div class="main-div-flex">
          <DxScrollView
            width="100%"
            height="100%"
          >
            <div class="center">
              <p class="center">
                {{ $t("navBar.popUp.countrySelect") }}
              </p>
              <div :class="`icon-country-${languageSelected}`" />
            </div>

            <div class="center">
              <p class="center">
                {{ $t("navBar.popUp.markerSelet") }}
              </p>
              <div class="icon-location" />
            </div>

            <div class="center">
              <p class="center">
                {{ $t("navBar.popUp.dataSelect") }}
              </p>
              <div :class="`icon-fields-${languageSelected}`" />
            </div>
          </DxScrollView>
        </div>
      </template>
    </DxPopup>
  </div>
</template>

<script>
import {
  mapState,
  mapActions,
} from 'vuex';
import { DxPopup } from 'devextreme-vue/popup';
import { DxScrollView } from 'devextreme-vue/scroll-view';
import SelectLanguage from './SelectLanguage.vue';
import { LANGUAGES } from '../js/constants';
import EventBus from '../js/event-bus';

export default {
  components: {
    SelectLanguage,
    DxPopup,
    DxScrollView,
  },
  props: {
    elements: { type: Array, default: () => [] },
    list: { type: Array, default: () => null },
    typeExport: { type: String, default: '' },
    pathBack: { type: String, default: '' },
    text: { type: String, default: '' },
  },
  data() {
    return {
      showPopUp: false,
      languages: LANGUAGES,
    };
  },
  computed: {
    ...mapState('authentication', ['user', 'languageSelected']),
  },
  methods: {
    backTo() {
      this.$f7.views.main.router.navigate(this.pathBack, {
        reloadCurrent: true,
      });
    },
    onHidden() {
      this.showPopUp = false;
    },
    changeLanguage(lan) {
      this.setLanguageSelected(lan);
      EventBus.$emit('change-language', lan);
    },
    ...mapActions('authentication', ['setLanguageSelected']),
  },
};
</script>
<style>
.chip {
  flex-direction: row-reverse;
  padding-right: 0;
  background: transparent;
}
.chip-media + .chip-label {
  margin-right: 20px !important;
}
.chip-label {
  color: var(--fr-chocolat) !important;
}
.chip-media {
  background: var(--fr-chocolat);
}
.ic-back {
  content: url("../static/img/ic_back.svg");
  height: 100%;
   width: 100%;
}
.button-back {
  background-color: #d6b35a;
  border: none;
}
#textBlock {
  margin-left: auto;
  margin-right: auto;
  line-height: 1.6em;
  padding-left: 10px;
}
.center {
  display: block;
  margin-left: auto;
  margin-right: auto;
  padding-top: 10px;
  padding-left: 10px;
}

.main-div-flex {
  display: flex;
  align-items: center;
  justify-content: center;
}

.icon-location {
  background-image: url("../static/img/info_popup_location.png");
  background-repeat: no-repeat;
  height: 62px;
  width: 55px;
}

.icon-country-es {
  background-image: url("../static/img/info_popup_country_es.png");
  background-repeat: no-repeat;
  height: 100px;
  width: 300px;
}

.icon-fields-es {
  background-image: url("../static/img/info_popup_fields_es.png");
  background-repeat: no-repeat;
  height: 200px;
  width: 339px;
}

.icon-country-en {
  background-image: url("../static/img/info_popup_country_en.png");
  background-repeat: no-repeat;
  height: 100px;
  width: 300px;
}

.icon-fields-en {
  background-image: url("../static/img/info_popup_fields_en.png");
  background-repeat: no-repeat;
  height: 200px;
  width: 339px;
}

.icon-country-ar {
  background-image: url("../static/img/info_popup_country_ar.png");
  background-repeat: no-repeat;
  height: 100px;
  width: 300px;
}

.icon-fields-ar {
  background-image: url("../static/img/info_popup_fields_ar.png");
  background-repeat: no-repeat;
  height: 200px;
  width: 339px;
}

.icon-country-gr {
  background-image: url("../static/img/info_popup_country_gr.png");
  background-repeat: no-repeat;
  height: 100px;
  width: 300px;
}

.icon-fields-gr {
  background-image: url("../static/img/info_popup_fields_gr.png");
  background-repeat: no-repeat;
  height: 200px;
  width: 339px;
}
</style>
